import { render, staticRenderFns } from "./PCguangao.vue?vue&type=template&id=03bdc74d&"
import script from "./PCguangao.vue?vue&type=script&lang=js&"
export * from "./PCguangao.vue?vue&type=script&lang=js&"
import style0 from "./PCguangao.vue?vue&type=style&index=0&id=03bdc74d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports